module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/components/narrow-col-event-calendar/narrow-col-event-calendar.component.scss
// module id = ./src/app/modules/backstage-module/components/narrow-col-event-calendar/narrow-col-event-calendar.component.scss
// module chunks = 9